import { AgmCoreModule } from '@agm/core';
import { AzcCoreModule, AzcMaterialModule, AzcStripeModule } from 'ac-ui-core-local';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { MatProgressBarModule, MatAutocompleteModule } from '@angular/material';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LayoutModule } from 'app/layout/layout.module';
import { environment, initializeConfig } from 'environments/environment';
import { AzcCommonModule } from './_common/azc-common.module';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app.routing.module';
import { DashboardComponent } from './dashboard/dashboard.component';

export function getStripeKey() {
	return environment.getConfig('stripeKey');
}

export function getUSStripeKey() {
	return environment.getConfig('usStripeKey');
}

@NgModule({
	declarations: [AppComponent, DashboardComponent],
	imports: [
		MatProgressBarModule,
		BrowserModule,
		BrowserAnimationsModule,
		LayoutModule,
		AppRoutingModule,
		AzcCommonModule,
		AzcCoreModule.forRoot(true),
		AzcMaterialModule,
		AzcStripeModule.forRoot(getStripeKey, getUSStripeKey),
		AgmCoreModule.forRoot({
			apiKey: environment.googleApiKey,
			libraries: ['places'],
		}),
		MatAutocompleteModule,
	],
	providers: [
		{
			provide: APP_INITIALIZER,
			useFactory: initializeConfig,
			multi: true,
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule {}
